// components/dashboard/CalendarSection.jsx
import React from 'react';
import { Calendar, Clock } from 'lucide-react';

const CalendarSection = () => {
    return (
        <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-[#437011] flex items-center mb-6">
                <Calendar className="w-6 h-6 mr-2" />
                Calendrier Voyages
            </h2>
            <div className="space-y-4">
                <div className="p-4 bg-[#F4F8E9] rounded-lg">
                    <p className="text-[#437011] font-medium">Prochain départ</p>
                    <div className="mt-2 flex items-center text-gray-600">
                        <Clock className="w-4 h-4 mr-2" />
                        <span>Dans 5 jours</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalendarSection;